import React, { useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import axios from "axios"
import Swal from 'sweetalert2'
import jwt from 'jsonwebtoken'
import { useHistory } from 'react-router-dom';


function onSubmitLogin(email, password, history) {
  // return Swal.fire({
  //   icon: 'success',
  //   title: 'Masih Di Tutup',
  //   showConfirmButton: false,
  //   timer: 1500
  // })
  axios.post(`${process.env.REACT_APP_API}/participant/login/`, {
    email,
    password
  })
    .then(async function (response) {
      const token = response.data.token;
      localStorage.setItem('token', response.data.token);
      var decoded = jwt.verify(token, process.env.REACT_APP_SECRET_PARTICIPANT);
      await Swal.fire({
        icon: 'success',
        title: 'Welcome',
        showConfirmButton: false,
        timer: 1500
      })
      history.push({
        pathname: '/menu/welcome',
        state: { participantId: decoded.id }
      })
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: `username atau password anda salah`,
          })
        } else if (error.response.status === 400) {
          if (error.response.data === "Empty Biodata") {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `kamu belum mengisi biodata dengan lengkap`,
            })
          }
        }
      } else {
        console.log(error)
      }
    });
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '} {new Date().getFullYear()} {' '}
      <Link color="inherit" href="https://www.jababeka.com/" target="_blank">
        Kawasan Industri Jababeka
      </Link>
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://drive.google.com/uc?export=view&id=1AHqXXDjLd5pO_vn_tpYhzuMFmP1qj38F)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'contain',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
}));

export default function LoginParticipant() {
  const classes = useStyles();
  const history = useHistory();
  const [user, setUser] = useState('')
  const [pass, setPass] = useState('')

  const handleChangeUser = (event) => {
    setUser(event.target.value);
  };

  const handleChangePass = (event) => {
    setPass(event.target.value);
  };

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar alt="Job Fair Logo" src="/participant/logo512.png" variant="square" className={classes.large} />
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <div className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="Username"
              label="Email"
              name="Username"
              autoComplete="Username"
              autoFocus
              value={user}
              onChange={handleChangeUser}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={pass}
              onChange={handleChangePass}
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={() => onSubmitLogin(user, pass, history)}
            >
              Sign In
            </Button>
            <Box mt={5}>
              <Copyright />
            </Box>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}